import * as yup from 'yup';

const validationSchemaPersonalDetails = yup.object({
  expYearCoursePage: yup
    .number()
    .typeError('Please enter valid years of experience')
    .min(1, 'Please enter valid years of experience')
    .integer('Please enter valid years of experience')
    .required('Please enter your years of experience'),
  phoneNumber: yup
    .string()
    .required('Please enter your phone number')
    .test(
      'phone-number-validation',
      'The phone number must be valid, and 10 digits (+91) or 7-15 digits (others)',
      function (value) {
        const {countryCode} = this.parent;
        if (countryCode === '+91') {
          return /^[1-9]\d{9}$/.test(value);
        }
        return /^\d{7,15}$/.test(value);
      }
    ),
  currentLocationCoursePage: yup
    .number()
    .typeError('Please select valid current location')
    .min(1, 'Please select valid current location')
    .required('Please select your current location'),
  name: yup
    .string()
    .required('Please enter your name')
    .matches(/^[a-zA-Z ]*$/, 'Please enter only alphabetical characters.')
    .max(75, 'Name can be of maximum 75 characters'),
  currentOrganizationCoursePage: yup
    .string()
    .matches(
      /^[a-zA-Z0-9 (-.',:!()&#+\[\]/*@^)]*$/,
      "Special characters other than (- . ' , : ! ( ) & + [ ] / * @ | ^) are not allowed"
    )
    .max(100, 'Organisation can be of maximum 100 characters')
    .when('expYearCoursePage', {
      is: 1,
      then: schema => schema.notRequired(),
      otherwise: schema => schema.required('Please enter your organisation'),
    }),
  // .required('Please enter your organisation'),
});

export default validationSchemaPersonalDetails;
